import { render, staticRenderFns } from "./resumePushStatistics.vue?vue&type=template&id=6e28914c&scoped=true"
import script from "./resumePushStatistics.vue?vue&type=script&lang=js"
export * from "./resumePushStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28914c",
  null
  
)

export default component.exports